import React, { useState } from 'react';
import './CalculatorPage.css';

function BusinessNameAnalysis() {
  const [name, setName] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const analyzeName = (inputName) => {
    // Placeholder for Business Name Analysis logic
    // This is a simplified example; real analysis would be more complex.
    if (!inputName) return null;
    let sum = 0;
    const nameMap = {
      'A': 1, 'J': 1, 'S': 1,
      'B': 2, 'K': 2, 'T': 2,
      'C': 3, 'L': 3, 'U': 3,
      'D': 4, 'M': 4, 'V': 4,
      'E': 5, 'N': 5, 'W': 5,
      'F': 6, 'O': 6, 'X': 6,
      'G': 7, 'P': 7, 'Y': 7,
      'H': 8, 'Q': 8, 'Z': 8,
      'I': 9, 'R': 9
    };

    for (let i = 0; i < inputName.length; i++) {
      const char = inputName[i].toUpperCase();
      if (nameMap[char]) {
        sum += nameMap[char];
      }
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return `The numerological value of your business name is ${sum}. This is a placeholder explanation for business name analysis.`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!name) {
      setError('Please enter a name.');
      return;
    }

    const calculated = analyzeName(name);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Business Name Analysis",
    "description": "Analyze your business name for numerological insights and potential for success.",
    "url": "https://www.yourwebsite.com/business-name-analysis",
    "potentialAction": {
      "@type": "AnalyzeAction",
      "name": "Analyze Business Name",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/business-name-analysis?name={name}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=name"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Business Name Analysis</h1>
      <p className="text-center">Enter your business name to get a numerological analysis.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="name">Business Name:</label>
          <input
            type="text"
            id="name"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., My Company Inc."
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Analyze Name</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Analysis:</h2>
          <p className="result-explanation">{result}</p>
        </div>
      )}
    </div>
  );
}

export default BusinessNameAnalysis;
